import { DateFormats, formatDate } from '@strata/helper-functions';

import { List } from 'components/List';
import { useGet } from 'services/Http';

const columns = ['Name', 'Code Type', 'Code', 'Change Date', 'Change Type', 'Username'];

export const ProductServiceHistory = () => {
    const history = useGet('/reference/productservices/productCodeChangeHistory');

    return (
        <List
            pageTitle="Product Service Code Change History"
            columnNames={columns}
            isLoading={!history}
            listData={history?.map((d) => [
                d.oid,
                d.codesystem,
                d.code,
                formatDate(d.change_date, DateFormats.DATE_TIME),
                d.change_type === 'D' ? 'Delete' : 'Add',
                d.change_username,
            ])}
        />
    );
};
